<template>
    <div id="offcanvasRight" class="offcanvas z_offcanvas offcanvas-end" tabindex="-1" aria-labelledby="offcanvasRightLabel">
        <div class="offcanvas-header">
            <button
                type="button"
                class="btn-close text-reset"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
            />
        </div>
        <div class="offcanvas-body">
            <template v-if="templateName === 'default'">
                <DefaultTemplates :invoice-data="invoiceData" />
            </template>
            <template v-else-if="templateName === 'system'">
                <SystemTemplates :invoice-data="invoiceData" />
            </template>
        </div>
    </div>
</template>

<script>
import { formatDateStrings } from "../../utils/helpers";
import DefaultTemplates from "./templates/Default.templates.vue";
import SystemTemplates from "./templates/System.templates.vue";

export default {
    name: "PreviewInvoice",
    
    components: {
        SystemTemplates,
        DefaultTemplates,
    },

    props: {
        invoiceData: {
            type: Object,
            default: undefined,
        },
    },

    data() {
        return {
            templateName: "default",
        };
    },

    computed: {
        computeItemsLengthText() {
            if (this.invoiceData.invoice.items.length > 1 || !this.invoiceData.invoice.items.length) {
                return "items";
            } else {
                return "item";
            }
        },

        user() {
            return this.$store.getters["auth/profile"];
        },

        profileUrlValue() {
            return this.user.profileImageUrl || "";
        },
    },
    
    methods: {
        formatDate(dateString) {
            if (typeof dateString === "object") {
                let stringDate = dateString.toString();
                return formatDateStrings(stringDate) || "N/A";
            }
            return dateString && typeof dateString === "string" ? formatDateStrings(dateString) : "N/A";
        },
    },
};
</script>

<style lang="scss" scoped>
    .offcanvas-end {
        width: 650px;
    }

    thead {
        border-style: solid !important;
    }

    th {
        padding-left: 0px !important;
    }

    .table tbody td {
        overflow-x: auto !important;
        white-space: normal !important;
        text-overflow: unset !important;
    }

    .preview {
        &__header {
            border-bottom: 1px solid #eee;
            padding-bottom: 15px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 1rem;
        }

        &__dates {
            display: flex;
            align-items: center;
            margin-bottom: 20px;
            border-bottom: 1px solid #eee;
            padding-bottom: 10px;
        }

        &__card {
            padding-top: 1.3rem;
        }

        &__row {
            display: flex;
            align-items: center;
            margin-bottom: 8px;
            width: 100%;
            justify-content: flex-end;

            &__text {
                font-size: 0.875rem;
                font-weight: 600;
                text-transform: uppercase;
                margin-left: 10px;
            }
        }

        &__card__item {
            &__title {
                font-weight: 500;
                margin-bottom: 3px !important;
                margin-top: 10px;
            }

            p {
                font-size: 0.875rem !important;    
            }
        }

        &__details {
            display: flex;
            align-items: baseline;

            &__item {
                flex: 1;
            }
        }

        &__logo {
            border: 1px solid #e6e6e6;
            padding: 10px;
            border-radius: 5px;
        }
    }
</style>